'use client';

import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';

export function CookieConsent() {
	const [showConsent, setShowConsent] = useState(false);

	useEffect(() => {
		// Check if user has already made a choice
		const hasConsented = localStorage.getItem('cookieConsent');
		if (!hasConsented) {
			setShowConsent(true);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem('cookieConsent', 'accepted');
		setShowConsent(false);
	};

	const handleDecline = () => {
		localStorage.setItem('cookieConsent', 'declined');
		setShowConsent(false);
		// Here you could disable PostHog and Sentry if needed
	};

	if (!showConsent) return null;

	return (
		<div className='fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-50'>
			<Card>
				<CardHeader>
					<CardTitle>Cookie Preferences</CardTitle>
					<CardDescription>
						We use cookies to improve your experience and analyze site usage.
					</CardDescription>
				</CardHeader>
				<CardContent>
					<p className='text-sm text-muted-foreground'>
						We use analytics tools to understand how you use our site and make
						it better. Event creators can see anonymous visit counts for their
						events. We never sell your data or use it for advertising.
					</p>
				</CardContent>
				<CardFooter className='flex gap-2 justify-end'>
					<Button variant='outline' onClick={handleDecline}>
						Decline
					</Button>
					<Button onClick={handleAccept}>Accept</Button>
				</CardFooter>
			</Card>
		</div>
	);
}
